/// <reference types="@types/googlemaps" />
import React from "react";
import "./App.css";
import Routes from "./config/Routes";
import { AuthContext } from "./Firebase/AuthProvider";
import theme from "./Theme";
import { ThemeProvider } from "@material-ui/core/styles";
import { BuildingProvider } from "Context/BuildingProvider";

function App() {
  return (
    <ThemeProvider theme={theme}>
      <BuildingProvider>
        <AuthContext.Consumer>
          {(auth) => <Routes user={auth.user} />}
        </AuthContext.Consumer>
      </BuildingProvider>
    </ThemeProvider>
  );
}

export default App;
